"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocation = exports.LocationProvider = void 0;
var tslib_1 = require("tslib");
var url_1 = (0, tslib_1.__importDefault)(require("url"));
var react_1 = (0, tslib_1.__importStar)(require("react"));
var LocationContext = (0, react_1.createContext)(null);
function LocationProvider(props) {
    var url = props.url, children = props.children;
    var location = url_1.default.parse(url, true);
    return react_1.default.createElement(LocationContext.Provider, { value: location }, children);
}
exports.LocationProvider = LocationProvider;
function useLocation() {
    var location = (0, react_1.useContext)(LocationContext);
    if (!location) {
        throw new Error('LocationProvider needs to be added to pages/_app');
    }
    return location;
}
exports.useLocation = useLocation;
//# sourceMappingURL=location.js.map